import React, { useState } from "react";
import ReactDOM from "react-dom";
import Terminal from "react-console-emulator";
import shouldPromptBeVisible from "react-console-emulator/dist/utils/shouldPromptBeVisible";

const trees = "⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⡄⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⢀⣼⣦⠀⠀⣠⣿⣿⣦⣀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⣼⣆⠀⠀⠀⠀⠀\n⠀⠀⠒⣿⣿⣿⠓⠀⠀⠻⣿⣿⠀⢀⣴⣿⣦⡀⠀⢀⣾⣦⠘⢿⣿⣧⡀⠀⠀⠀\n⠀⢀⣴⣿⡿⠃⡄⠈⠻⣿⣟⣉⣀⠉⣽⡿⠋⠡⠴⣿⣿⣿⠓⠀⠙⢇⠀⠀⠀⠀\n⠀⠿⣿⠟⢁⣾⣿⣦⣀⠘⠿⠟⢁⣼⣿⣿⣷⠂⣴⣿⣿⣿⣆⠘⢶⣶⣿⠶⠤⠀\n⠀⣀⣀⡀⢉⣿⣿⣿⡍⠀⢀⣀⠙⢻⠿⢋⣤⣾⣿⣿⣿⣿⣿⣷⣄⠙⢿⣦⡀⠀\n⠀⠟⠋⣠⣾⣿⣿⣿⣿⣦⣌⠉⠠⣤⣤⣤⡌⢙⣿⣿⣿⣿⣿⣿⠛⠛⠂⢈⣙⠀\n⠀⠀⣉⡉⣹⣿⣿⣿⣿⣏⠉⣉⣀⣈⠙⠋⣠⣿⣿⣿⣿⣿⣿⣿⣆⠙⠛⠛⠛⠀\n⠀⠀⠋⣴⣿⣿⣿⣿⣿⣿⣷⣌⠉⢁⣴⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣷⣄⠀⠀⠀\n⠀⠴⢾⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⠦⠈⣙⠛⠛⠛⠛⠛⠛⠛⠛⣉⣉⠁⠀⠀⠀\n⠀⠀⣦⣤⡄⢉⣉⣉⣉⠉⣡⣤⠀⠀⠀⣿⣿⣷⠀⢰⣿⣿⡇⢸⣿⣿⠀⠀⠀⠀\n⠀⠀⣿⣿⡇⣸⣿⣿⣿⡄⢻⣿⠀⠀⠀⣿⣿⣿⠀⢸⣿⣿⡇⢸⣿⣿⠀⠀⠀⠀\n⠀⠀⣿⣿⠁⣿⣿⣿⣿⡇⠸⠿⠀⠀⠀⣿⣿⣿⠀⢸⣿⣿⣇⠸⣿⣿⠀⠀⠀⠀\n⠀⠀⠛⠛⠀⣿⣿⣿⣿⡇⠀⠀⠀⠀⠀⠉⠉⠉⠀⢸⣿⣿⣿⠀⠿⠿⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠛⠛⠛⠛⠃⠀⠀⠀⠀⠀⠀⠀⠀⠀⠈⠉⠉⠉⠀⠀⠀⠀⠀⠀⠀";
const branches = "⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣠⡤⠀⡀⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⣤⠀⠀⠀⣠⡾⠋⣠⣾⣿⣷⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠈⢉⣠⣄⡼⠋⣠⣾⣿⣿⣿⡟⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⡤⠀⣀⡿⠋⣠⣾⣿⣿⣿⡿⠋⡀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⣠⠶⠋⢠⣾⣿⣧⣼⣿⣿⣿⡿⠋⣠⡾⠟⠿⢶⡄⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⣠⡞⠁⠀⠀⠀⢄⠙⢿⣿⣿⣿⠋⣠⡾⠋⣠⣶⣶⣄⢹⠀⠀⠀\n⠀⠀⠀⠀⠀⠺⠟⠀⠀⡌⠉⣢⠈⣷⠀⢿⠟⢁⡴⠋⣠⣾⣿⣿⣿⠟⠀⠀⠀⠀\n⠀⠀⠀⡖⠚⠲⣄⠈⣄⠙⠚⠋⣠⣿⠀⢀⡴⠋⢠⣾⣿⣿⣿⠟⠁⣠⣤⣤⠀⠀\n⠀⠀⠘⡇⠻⠇⡼⠀⡈⠛⠶⠿⠛⠁⣴⠏⢠⠄⢤⡄⢹⠟⠁⣠⣾⣿⠟⢁⡄⠀\n⠀⠀⠀⢈⣉⡉⠀⢾⡿⠃⣀⡤⠶⣤⣄⠀⢻⣀⣀⠇⠀⣠⣾⣿⠟⢁⡴⠋⠀⠀\n⠀⢀⡴⠛⠛⠛⢷⡄⠁⡼⢁⣤⣤⣄⠹⣷⠀⠈⠁⠀⠚⢿⣿⣿⣷⠟⠁⠀⠀⠀\n⠀⠘⠀⡟⠛⣷⠀⡷⠀⡇⠸⣇⢀⣿⠀⣿⠀⢀⡾⠛⠓⠄⠙⠟⠁⠀⠀⠀⠀⠀\n⠀⠀⠀⠓⠒⠋⠀⠁⠀⠙⢤⣈⣉⣡⠾⠋⠀⠘⣇⠘⢁⠌⠀⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀";
const sandwich = "⠀⢠⣀⣠⠖⠒⠒⣶⠲⣤⠤⣄⣀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀\n⠀⣿⢰⡏⠀⠀⣰⡷⠋⠀⢀⡼⠉⡩⠓⠒⠦⣄⣀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀\n⢸⡃⠸⡇⠀⠐⠛⠀⠀⠀⡾⢡⠎⠀⠀⠀⠀⠀⣨⡿⢲⣦⣄⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀\n⢈⣿⡆⢻⡀⠀⠀⠀⠀⠸⡇⡎⠀⠀⠀⠀⣠⣾⠟⠉⠀⠀⠀⠙⠳⢤⣀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀\n⠸⣾⣇⣀⣹⣄⠀⠀⠀⠈⣿⠀⠀⠀⢀⡞⡝⠁⠀⠀⠀⠀⠀⢀⣠⡴⠟⠛⠦⣀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀\n⠀⢻⣿⣿⣦⣹⠦⡀⠀⠀⠀⠀⠀⠀⣾⠜⠀⠀⠀⠀⠀⢀⡴⠛⡡⠔⠒⠈⠉⠉⠑⢦⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⠳⡝⢯⣻⡀⠉⢢⣄⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣠⢏⡴⠋⠀⠀⠀⠀⠀⠀⠀⣀⣈⣳⣄⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠙⢦⡙⠻⣯⡉⢯⠑⢦⣀⠀⠀⠀⠀⠀⠀⠀⡧⠊⠀⠀⠀⠀⠀⠀⢠⠴⠋⣉⡠⠤⠬⢷⡄⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠙⢦⡙⠫⢿⠟⠉⣿⡗⢦⣄⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣰⡡⠔⠉⠀⠀⠀⠀⠀⠘⢦⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠙⢷⣌⠓⠤⣙⣿⣦⣉⠛⠶⣄⡀⠀⠀⠀⠀⠀⠀⡼⠋⠀⠀⠀⠀⠀⠀⠀⠀⠀⠈⣧⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⠀⠉⠳⣦⣀⠉⠻⣝⠛⠶⠾⣟⣳⣦⣄⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢸⡦⠤⣄\n⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠙⠳⣦⣀⠙⢦⣀⣰⣯⣧⣉⣛⡶⣦⣄⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣸⢇⣠⠾\n⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠉⠳⢦⣀⠀⠙⠫⣽⠫⣱⢤⣉⡛⢻⠶⢦⣤⣄⣀⣀⣀⣀⡴⠏⠸⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠉⠛⢦⣀⡷⠶⠬⢭⣓⣒⠚⢇⡠⠋⢧⠀⢉⣵⣧⠀⢀⡄⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠈⠙⠲⢤⣀⡀⠉⠉⠛⠓⠶⠤⣭⣁⣿⢛⡿⠋⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠈⠙⠛⠶⠶⢤⣤⣤⣤⡴⠞⠋⠀⠀⠀⠀⠀";
const hat = "⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⣀⣀⣀⣀⣀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⢰⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣷⣶⣤⣀⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⢀⠙⠿⢿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⠿⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⣷⣶⣤⣄⣈⣉⣉⣉⣉⣉⣉⣉⣁⣤⡄⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⡇⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⡇⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⢀⠀⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⣿⡇⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⢀⣠⣶⣾⡏⢀⡈⠛⠻⠿⢿⣿⣿⣿⣿⣿⠿⠿⠟⠛⢁⠀⢶⣤⣀⠀⠀⠀\n⠀⢠⣿⣿⣿⣿⡇⠸⣿⣿⣶⣶⣤⣤⣤⣤⣤⣤⣤⣶⣶⣿⡿⠂⣸⣿⣿⣷⡄⠀\n⠀⢸⣿⣿⣿⣿⣿⣦⣄⡉⠛⠛⠛⠿⠿⠿⠿⠛⠛⠛⢉⣁⣤⣾⣿⣿⣿⣿⡷⠀\n⠀⠀⠙⢿⣿⣿⣿⣿⣿⣿⣿⣷⣶⣶⣶⣶⣶⣶⣾⣿⣿⣿⣿⣿⣿⣿⡿⠛⠁⠀\n⠀⠀⠀⠀⠈⠙⠛⠿⠿⢿⣿⣿⣿⣿⣿⣿⣿⣿⡿⠿⠿⠿⠛⠛⠉⠁⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀";
const end = "'########:'##::::'##:'########::::'########:'##::: ##:'########::\n<b><span style='color:#EE9C34;'>... ##..:: ##:::: ##: ##.....::::: ##.....:: ###:: ##: ##.... ##:\n<b><span style='color:#EE9C34;'>::: ##:::: ##:::: ##: ##:::::::::: ##::::::: ####: ##: ##:::: ##:\n<b><span style='color:#EE9C34;'>::: ##:::: #########: ######:::::: ######::: ## ## ##: ##:::: ##:\n<b><span style='color:#EE9C34;'>::: ##:::: ##.... ##: ##...::::::: ##...:::: ##. ####: ##:::: ##:\n<b><span style='color:#EE9C34;'>::: ##:::: ##:::: ##: ##:::::::::: ##::::::: ##:. ###: ##:::: ##:\n<b><span style='color:#EE9C34;'>::: ##:::: ##:::: ##: ########:::: ########: ##::. ##: ########::\n<b><span style='color:#EE9C34;'>:::..:::::..:::::..::........:::::........::..::::..::........:::";
const fireLow = "⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠐⠀⣰⠀⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⠂⡀⡟⢾⠶⠋⠀⡀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⢠⣧⣧⣸⣿⣿⠃⠀⠀⠀⣤⡇⠀⠀⠀⠀⠀⠀\n⠀⠀⢰⢹⣿⠙⠻⠟⠋⠁⠀⠀⠀⠀⢿⣇⡀⠊⠀⠀⠀⠀\n⠀⠈⣾⣿⣿⡆⠀⠀⢀⣠⡤⠀⠀⠀⠈⠻⣿⡧⣄⠀⢠⠀\n⠀⠀⠘⠟⠋⣁⣤⡾⢟⣩⣴⣶⣆⠀⠀⠀⠀⢠⣿⣦⣿⠀\n⠀⢀⣠⣴⣿⣿⣿⣿⠟⢉⣁⣀⣉⠀⢹⣶⣶⣤⣄⣈⡁⠀\n⢸⣿⣿⣿⣿⢿⣿⠇⢰⡟⣫⣦⠙⢷⡀⣿⣿⣯⣍⣛⠛⠋\n⠀⠛⢋⣡⡾⠟⠋⠀⠸⣧⣙⡟⢁⡾⠁⠿⢿⣿⣿⣭⡉⠁\n⠀⠀⠈⠁⠀⠀⠀⠀⠀⠈⠙⠛⠋⠀⠀⠀⠀⠀⠈⠉⠉⠀\n"
const oldMan = "⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⣀⣀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⢀⣠⡤⠶⠭⠥⣼⣽⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⣠⠞⠉⠀⠀⠀⠀⠀⠀⠀⠉⠓⢦⡀⠀⠀⠀⠀⠀⠀\n⠀⠀⡤⠞⢋⡟⣡⣤⠶⣶⡄⠀⠀⠀⢠⡶⠶⢦⣄⠙⣦⠤⢤⡀⠀⠀\n⢀⡞⣡⢤⡾⠈⣵⠒⠶⢦⡀⢠⠖⠀⢠⡔⠒⠶⣮⠀⠘⣦⣤⡙⣆⠀\n⢸⢿⡇⢰⠇⠀⠙⠒⠶⠋⢀⡏⠀⠀⠀⠙⠒⠚⠉⠀⠀⢹⠀⣹⠸⡆\n⣾⠀⣉⢻⡄⠀⠀⠀⠀⣸⣼⣆⠀⣸⣤⡆⠀⠀⠀⠀⠀⢸⠞⠁⠀⢷\n⠈⠉⠉⠛⢷⡀⠀⠀⠰⣿⣿⣿⣿⣿⣿⣿⠀⠀⠀⠀⠀⡼⠶⠚⠛⠋\n⠀⠀⠀⠀⠀⠳⣄⠀⠀⠀⠀⠀⠉⠀⠈⠁⠀⠀⠀⣠⠞⠁⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠈⠛⠦⣄⣀⠀⠀⠀⠀⣀⣠⡴⠚⠁⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⣠⢾⣈⠉⠉⢉⣉⣁⡿⢤⡀⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⡟⠀⠈⠉⠉⠉⠉⠁⠀⠈⣧⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⢀⣠⠤⠶⠚⠁⠀⠦⠤⠤⠤⠤⠖⠂⠀⠈⠓⠦⢤⣀⠀⠀⠀\n⠀⢀⡞⠋⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠈⠳⣄⠀\n⢀⡞⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠹⡆\n⣸⠀⠀⠀⢀⡇⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣇⠀⠀⠀⠀⣷\n⡏⠀⠀⠀⢸⠁⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢹⠀⠀⠀⠀⢸\n⠃⠀⠀⠀⠛⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢘⠁⠀⠀⠀⠘";
const capy = "⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⣄⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣸⣬⠷⣶⡖⠲⡄⣀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⣠⠶⠋⠁⠀⠸⣿⡀⠀⡁⠈⠙⠢⠤⣀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⢠⠞⠁⠀⠀⠀⠀⠀⠉⠣⠬⢧⠀⠀⠀⠀⠈⠻⣤⣀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⢀⡴⠃⠀⠀⢠⣴⣿⡿⠀⠀⠀⠐⠋⠀⠀⠀⠀⠀⠀⠘⠿⡄⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀\n⠀⢀⡴⠋⠀⠀⠀⠀⠈⠉⠉⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠈⠙⠒⠒⠓⠛⠓⠶⠶⢄⣀⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀\n⢠⠎⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠈⠙⠦⣀⠀⠀⠀⠀⠀⠀⠀⠀\n⡞⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠸⢷⡄⠀⠀⠀⠀⠀⠀\n⢻⣇⣹⣿⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠙⢦⡀⠀⠀⠀⠀\n⠀⠻⣟⠋⠀⠀⠀⠀⠀⣀⣀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠻⣄⠀⠀⠀\n⠀⠀⠀⠉⠓⠒⠊⠉⠉⢸⡙⠇⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⡀⠀⠀⠀⠀⠘⣆⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣱⡄⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣀⣿⠀⠀⠀⠀⠀⢻⡄⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠟⣧⡀⠀⠀⢀⡄⣀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⡿⠇⠀⠀⠀⠀⠀⠀⢣⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠠⡧⢿⡀⠚⠿⢻⡆⠀⠀⠀⠀⠀⢠⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣿⡇⠀⠀⠀⠀⠀⠀⠀⠘⡆\n⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠘⣿⠀⠀⠈⢹⡀⠀⠀⠀⠀⣾⡆⠀⠀⠀⠀⠀⠀⠀⠀⠾⠇⠀⠀⠀⠀⠀⠀⠀⠀⠀⡇\n⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠨⢷⣾⠀⠸⡷⠀⠀⠀⠘⡿⠂⠀⠀⠀⢀⡴⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢠⡇\n⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢸⡄⠳⢼⣧⡀⠀⠀⢶⡼⠦⠀⠀⠀⡞⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢸⠃\n⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢸⡇⠀⡎⣽⠿⣦⣽⣷⠿⠒⠀⠀⠀⣇⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣸⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣸⠁⣴⠃⡿⠀⠀⢠⠆⠢⡀⠀⠀⠀⠈⢧⣄⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢠⠇⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣀⣠⣠⠏⠀⣸⢰⡇⠀⢠⠏⠀⠀⠘⢦⣀⣀⠀⢀⠙⢧⡀⠀⠀⠀⠀⠀⠀⠀⠀⡰⠁⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠾⠿⢯⣤⣆⣤⣯⠼⠀⠀⢸⠀⠀⠀⠀⠀⣉⠭⠿⠛⠛⠚⠟⡇⠀⠀⣀⠀⢀⡤⠊⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠈⠉⠀⢸⣷⣶⣤⣦⡼⠀⠀⠀⣴⣯⠇⡀⣀⣀⠤⠤⠖⠁⠐⠚⠛⠉⠁⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣛⠁⢋⡀⠀⠀⠀⠀⣛⣛⠋⠁⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀";
const fire = "⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⢀⣀⠀⠀⠀⠀⠀⠀⠀⢱⣄⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⢸⣿⡄⠀⠀⡀⠀⠀⠀⢸⣿⣷⡄⠀⠀⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⠈⢿⠇⠀⠀⣷⣦⣤⣴⣿⣿⣿⣷⠀⠀⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠀⠀⡀⠀⠀⠀⠀⣿⣿⣿⣿⣿⣿⣿⡿⠀⠀⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⢠⣾⣷⡀⠀⠀⣸⣿⣿⣿⣿⣿⣿⣿⠃⠀⠀⠀⠀⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⢰⣿⣿⣿⣿⣷⣿⣿⣿⡟⢿⠿⠋⣿⣿⠀⠀⠀⠀⠰⣄⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⣾⣿⣿⣿⣿⣿⣿⣿⣿⠃⠀⠀⠀⣿⣿⣦⡀⠀⠀⢀⣿⣧⠀⠀⠀\n⠀⠀⠀⠀⠀⢹⣿⣿⣿⠙⠻⠟⠋⠁⠀⠀⠀⠀⢿⣿⣿⣿⣶⣶⣿⣿⣿⠀⠀⠀\n⠀⠀⠀⠀⠀⠈⣿⣿⣿⡆⠀⠀⢀⣠⡤⠀⠀⠀⠈⠻⣿⡿⣿⣿⣿⣿⡟⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠘⠟⠋⣁⣤⡾⢟⣩⣴⣶⣆⠀⠀⠀⠀⢠⣿⣿⣿⠟⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⢀⣠⣴⣿⣿⣿⣿⠟⢉⣁⣀⣉⠀⢹⣶⣶⣤⣄⣈⡁⠀⠀⠀⠀⠀\n⠀⠀⠀⠀⢸⣿⣿⣿⣿⢿⣿⠇⢰⡟⣫⣦⠙⢷⡀⣿⣿⣯⣍⣛⠛⠋⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠛⢋⣡⡾⠟⠋⠀⠸⣧⣙⡟⢁⡾⠁⠿⢿⣿⣿⣭⡉⠁⠀⠀⠀⠀\n⠀⠀⠀⠀⠀⠀⠈⠁⠀⠀⠀⠀⠀⠈⠙⠛⠋⠀⠀⠀⠀⠀⠈⠉⠉⠀⠀⠀⠀⠀"
// cmd + option + shift for multiple cursors
const places = {
  intro: {
    desc:
      "You stand at the edge of a forest clearing. A full moon shines brightly overhead.\n A <b><span style='color:#EE9C34;'>campfire</b></span> burns in the center of the clearing, and behind it sits a mustachioed old <span style='color:#EE9C34;'><b>man</b></span>.\n",
      things: ["man", "campfire"],
      takeable: []
  },
  forest: {
    desc:
      "The old man has gone, and the <b><span style='color:#EE9C34;'>campfire</b></span> is going out. It's very cold, and you've begun to shiver. \nYou remain in the clearing, surrounded by <b><span style='color:#EE9C34;'>trees</b></span> on all sides.",
      things: ["campfire", "trees"],
      takeable: []
  },
};

let lookResponses = {
  "man" : "T"
}

const STARTING_PLACE = "intro";

const items = {
  napkins: {
    name: "some used napkins"
  },
  stump: {
    tooHeavy: true
  }
};

let name = "Stranger";




let inventory = ["pocket lint"];


let awake = false;
let spokenWithMan = false;
let nameSet = false;
let seenTrees = false;
let branchesTaken = false;
let branchesUsed = false;
let spokenWithCapy = false;
let gameWon = false;


const interactions = {
  "man" : {
    look: `${oldMan}\nThe old <b><span style='color:#EE9C34;'>man</b></span> has a bushy white mustache. He beckons to you to join him by the campfire.\nTry talking to him.`,
    talk: `<i><b>"Welcome, traveler,"</i></b> the old man says with a smile. <i><b>"Before we proceed, tell me your name."</i></b>\n State your name by typing <b>'name <i>yourName</i>'</b>.`,
    awaken: `<i>"I am not asleep, Stranger,"</i> the old man says.`
  },
  "campfire" : {
    look: `${fire}\nThe campfire burns strong. It's inviting and warm. It makes these woods feel less hostile.`,
    talk: "You say hello to the campfire. It crackles a bit, but says nothing in response.",
    awaken: "Fire doesn't sleep, but you push a log anyway."
  },
  "trees" : {
    look: `${trees}\nYou walk to the edge of the clearing to inspect the <b><span style='color:#EE9C34;'>trees</b></span>.\nYou notice quite a few <b><span style='color:#EE9C34;'>branches</b></span> laying around.`,
    talk: `You are about to say hello to the trees when you hear a haunting howl in the distance.\n You decide to keep your mouth shut.`,
    awaken: `Who can awaken the spirits of the forest? Not I.`
  },
  "branches" : {
    look: `${branches}\nYou look at the pile of <b><span style='color:#EE9C34;'>branches</b></span>. They are dry, and would probably burn well.\nMaybe you should <b>'take'</b> them?`,
    talk: `A large treebranch says <i><b>"Hey buddy!"</i></b>\n . . . \n Just kidding.`,
    awaken: `Be serious, man. The fire is almost out, and it's freezing.`,
    take: `You pick up as many branches as you can carry. Yup, these will do the trick!`,
    use: `You add some branches to the campfire. It roars back to life!\n A friendly <b><span style='color:#EE9C34;'>visitor</b></span> appears from the edge of the clearing and joins you by the fire.`
  },
  "visitor" : {
    look: `${capy}\nThe <b><span style='color:#EE9C34;'>visitor</b></span> warms himself by the fire. \nHe seems like a cool guy. It appears he wants to <b>talk</b> with you.`,
    talk: `Howdy, Stranger! If you're seeing this, it's a bug. :-(`,
    awaken: `Your visitor is plenty awake. Seems like he wants to <b>talk</b>.`
  },
  "sandwich" : {
    look: `${sandwich}\nIt is a tasty-looking sandwich, the kind that can really turn a bad day around. You wonder if there's any hot mustard on it.`,
    talk: `You ask the sandwich if it has any hot mustard. The sandwich remains silent, but the visitor nods with a smile.`,
    awaken: `You poke the sandwich. Seems like it's not awake. Or alive.`
  },
  "hat" : {
    look: `${hat}\nWow, that is a cool hat. With a hat like that, you'd be the talk of the town!`,
    talk: `You tell the hat how cool it is. Rudely, it says nothing, but the visitor grins.`,
    awaken: `A cool hat never sleeps.`
  }
}

const MyTerminal = () => {
  // let [place, setPlace] = useState(STARTING_PLACE);
  let place = STARTING_PLACE;
  const commands = {
    look: {
      description: "Look around, or at something.",
      fn: (args) => {
        if (gameWon) {
          return `${name}, didn't you see? You already won!`
        }
        if (awake) {
          if (args) {
              if (places[place].things.includes(args)) {
                if (args == "trees" && !branchesTaken) {
                  seenTrees = true;
                  places[place].things[2] = "branches";
                  places[place].takeable[0] = "branches";
                  places[place].desc = "The <b><span style='color:#EE9C34;'>campfire</b></span> is nearly out. You remain in the clearing, surrounded by <b><span style='color:#EE9C34;'>trees</b></span> on all sides.\nThere are a number of dry, broken <b><span style='color:#EE9C34;'>branches</b></span> scattered about."
                }
                return interactions[args].look;
              } 
              else {
                return `There's no ${args} here...`;
              }
            }
            else {
              // console.log(args);
              console.log(place)
              return places[place].desc;
              }
          }
        else {
          return `How can you look around before you've woken up?\n Enter 'awaken' to begin the game.`
        }
      }
    },
    talk: {
      description: "Have a chat.",
      fn: (args) => {
        if (gameWon) {
          return `${name}, there is nothing left to say. You won!`
        }
        if (awake) {
          if (args) {
              if (places[place].things.includes(args)) {
                if (args == "man" && !spokenWithMan) {
                  spokenWithMan = true;
                  interactions["man"].look = `${oldMan}\nThe old <b><span style='color:#EE9C34;'>man</b></span> has a bushy white mustache. He asked for your name... how about you tell him?\nTry typing <b>'name <i>yourName</i>'</b>.`;
                }
                if (args == "visitor" && !spokenWithCapy) {
                  places[place].things.push("sandwich","hat")
                  places[place].desc = "You are seated by a lively <b><span style='color:#EE9C34;'>campfire</b></span>.\nThe friendly <b><span style='color:#EE9C34;'>visitor</b></span> sits across from you, offering your choice of <b><span style='color:#EE9C34;'>sandwich</b></span> or <b><span style='color:#EE9C34;'>hat</b></span>.\nWhich will you <b>take</b>?"
                  interactions["visitor"].look = `The <b><span style='color:#EE9C34;'>visitor</b></span> is offering you a choice of a <b><span style='color:#EE9C34;'>sandwich</b></span> or a <b><span style='color:#EE9C34;'>hat</b></span>. \nHe doesn't appear to be trying to trick you.`
                  spokenWithCapy = true;
                }
                else if (args == "visitor" && spokenWithCapy) {
                  return `"<b><i>It is your choice, ${name}: <b><span style='color:#EE9C34;'>sandwich</b></span>, or <b><span style='color:#EE9C34;'>hat</b></span>. You may only take one."</b></i>`
                }
                return interactions[args].talk;
              } 
              else {
                return `You'd like to talk to ${args}, but there's no ${args} here...`;
              }
            }
            else {
              return `"Hi!" ...you say to no one in particular.`;
              }
          }
        else {
          return `You're mumbling in your sleep.\n Enter 'awaken' to begin the game.`
        }
      }
    },
    take: {
      description: "Pick something up. Very useful if you encounter tree branches.",
      fn: (args) => {
        if (gameWon) {
          return `What more is there to take, ${name}? You've already won!`
        }
        if (awake) {
          if (args) {
            if (places[place].things.includes(args)) {
              // nasty code, but since only branches can be taken, I can skip some steps here...
              if (places[place].takeable.includes(args) && !branchesTaken && args == "branches") {
                branchesTaken = true;
                interactions["trees"].look = `The <b><span style='color:#EE9C34;'>trees</b></span> trees haven't changed much since the last time you looked.\nBut, the <b><span style='color:#EE9C34;'>branches</b></span> in your arms are starting to feel pretty heavy.\nMaybe you should do something with them.`
                interactions["branches"].look = `You look at the branches in your arms. <i>Yup, that's a lotta branches!`
                interactions["campfire"].look = `${fireLow}\nThe <b><span style='color:#EE9C34;'>campfire</b></span> is nearly out. <b>Use</b> those branches, damn it!`
                places[place].desc = "The <b><span style='color:#EE9C34;'>campfire</b></span> is nearly out. You remain in the clearing, surrounded by <b><span style='color:#EE9C34;'>trees</b></span> on all sides.\nYou're holding a bunch of dry <b><span style='color:#EE9C34;'>branches</b></span> in your arms."
                return interactions[args].take;
              } 
              else if (places[place].takeable.includes(args) && branchesTaken && args == "branches") {
                return `How could you take what you've already taken?`
              }
              else if (spokenWithCapy && args == "sandwich") {
                // END
                gameWon = true;
                return `After a great deal of thought, you take the sandwich. The visitor smiles, nods, and disappears into the forest.\nYou eat half of the sandwich and save the rest for later. In the morning, you come upon a lost maiden in the woods.\nYou offer her the remaining half of your sandwich. Struck by your impeccable taste in deli meats, she falls in love with you immediately.\n Together, you open a sandwich shop, and it soon becomes the most renowned sandwich shop in all the land.\nThe two of you live happily ever after.\n<b><span style='color:#EE9C34;'>${end}</b></span>`
              }
              else if (spokenWithCapy && args == "hat") {
                // END
                gameWon = true;
                return `It's a tough choice, but you reach for the hat. It's just so cool. The visitor agrees.\nThe next day, while adventuring through the woods, you come upon a lost maiden. Seeing you in your cool hat, she falls in love immediately.\nTogether, you open a haberdashery, and it soon becomes the most renowned haberdashery in all the land.\nThe two of you live happily ever after. \n<b><span style='color:#EE9C34;'>${end}</b></span>`
              }
              else {
                return `Sorry, but ${args} can't be taken...`;
              }
            }
            else {
              return `There's no ${args} to take...`
            }
          }
            else {
              return `Take what?`;
              }
          }
        else {
          return `The only thing you're taking right now is a nap.\n Enter 'awaken' to begin the game.`
        }
      }
    },
    use: {
      description: "Use something. I'll give you a hint: <b>BRANCHES!</b>",
      fn: (args) => {
        if (gameWon) {
          return `How about you <b> use </b> this moment to reflect on the journey, ${name}? You've already won!`
        }
        if (awake) {
          if (args) {
            // Hardcoding now. Running out of time...
            if (args == "branches") {
              if (branchesTaken && !branchesUsed) {
                branchesUsed = true;
                places[place].things.splice(2,1);
                places[place].things.push("visitor");
                interactions["visitor"].talk = `<b><i>"Hello, ${name}! It is I, the Spirit of the Forest. I am impressed by your ability to use branches."</b></i>\nThe <b><span style='color:#EE9C34;'>visitor</b></span> grins. <i><b>"You have passed the Trial of the Forest. You may choose your reward."</i></b>\nHe holds out two paws. In one: a large <b><span style='color:#EE9C34;'>sandwich</b></span>. The other: a cool <b><span style='color:#EE9C34;'>hat</b></span>.\nYou may only <b>take</b> one.`
                console.log(places[place].things);
                // Campfire is back to full strength
                interactions["campfire"].look = `${fire}\nThe <b><span style='color:#EE9C34;'>campfire</b></span> is lively and very warm.\nYou feel very smart for knowing how to use branches.`
                interactions["campfire"].talk = `The campfire is grateful for your assistance, but cannot express its gratitude through speech.`
                interactions["campfire"].awaken = `<i><b>"I'm wide awake!"</i></b> ...you imagine the campfire would say this to you.`
                interactions["trees"].look = `The <b><span style='color:#EE9C34;'>trees</b></span> trees haven't changed much since the last time you looked.`
                // General scene is changed
                places[place].desc = "You are seated by a lively <b><span style='color:#EE9C34;'>campfire</b></span>.\nA friendly <b><span style='color:#EE9C34;'>visitor</b></span> sits across from you. The surrounding woods reflect the glowing full moon overhead."
                return "You use the branches to feed the hungry fire.\nThanks to your pyrotechnic prowess, the <b><span style='color:#EE9C34;'>campfire</b></span> has roared back to life.\nIt is warm and inviting. So much so that a friendly <b><span style='color:#EE9C34;'>visitor</b></span> has joined you by the fire. Who is it?";
              }
              else if (branchesTaken && branchesUsed) {
                return `You don't have any more branches. What would you use them for, anyway?`
              }
              else {
                return `You're definitely onto something here. However, you don't have any branches...`
              }
            }
            else {
              return `You can't use ${args}!`
            }
          }
            else {
              return `Use what?`;
              }
          }
        else {
          return `Maybe try <b>using</b> your brain first.\n Enter 'awaken' to begin the game.`
        }
      }
    },
    awaken: {
      description: "Wake yourself, or someone else.",
      fn: args => {
        if (gameWon) {
          return `You've already won, ${name}. Maybe it's time to get some rest?`
        }
        if (args) {
          if (places[place].things.includes(args)) {
            return interactions[args].awaken;
          }
          else {
            return `There's no ${args} here...`
          }
        } else {
          if (awake == false) {
            awake = true;
            return "You open your eyes. It seems you fell asleep in the woods.\n Type 'look' to look around.\n Type 'help' to learn about other commands."
        } else {
         return "You're already awake."
        }
        }
        
      }
    },
    name: {
      description: "State your name.",
      fn: args => {
        if (gameWon) {
          return `Your name is ${name}: Winner of Bizork!`
        }
        if (awake) {
          if (args) {
            if (!nameSet) {
              if (spokenWithMan) {
                name = args;
                nameSet = true;
                place = "forest";
                // change fire to low. task is now to fix the fire
                interactions["campfire"].look = `${fireLow}The campfire is starting to go out, and the night is cold.\nYou should probably do something about it.`
                interactions["campfire"].talk = `The campfire is so low now, it really doesn't feel like talking.`
                interactions["campfire"].awaken = `You try waking the campfire with a motivational speech. It doesn't seem to work.`
                return `<b><i>"Of course!"</b></i> The man smiles. <b><i>"Hello, ${name}."</b></i>\n The man stares into the <b><span style='color:#EE9C34;'>campfire</b></span> for a moment, which has begun to die down.\n He stands up. <i><b>"You will be faced with a test. Good luck."</i></b>\n The man walks into the darkness of the forest.`;
              }
              else {
                return `Okay, your name is ${args}. Maybe you can find someone who'd like to know...`
              }
            }
            else {
              return `${args}? I thought your name was ${name}...`
            }
          }
          else {
            if (nameSet) {
              return `${name}! ...you say, for no particular reason.`
            }
            else{
              return "But, what <i>is</i> your name?"
            }
          }
      } else {
        return `How can you state your name while you're asleep? Try waking up first.`
      }
      }
    },
  }
  
  let globalStyles = {
    minHeight : '600px',
    maxHeight : '600px'
  }
  let contentStyle = {
    fontFamily: "monospace"
  }

  let promptLabelStyle = {
    fontFamily:"monospace"
  }
  
  let inputTextStyle = {
    fontFamily:"monospace"
  }

  return (
    // Add styling, commands here
    <Terminal
      commands={commands}
      style={globalStyles}
      contentStyle={contentStyle}
      promptLabelStyle={promptLabelStyle}
      inputTextStyle={inputTextStyle}
      dangerMode={true}
      welcomeMessage={"Welcome to...\n<b><span style='color:#EE9C34;'> * * * * * * * * * * * * * * * * * * * * * * * * * * *\n<b><span style='color:#EE9C34;'> .########..####.########..#######..########..##....##\n<b><span style='color:#EE9C34;'>.##.....##..##.......##..##.....##.##.....##.##...##.\n<b><span style='color:#EE9C34;'>.##.....##..##......##...##.....##.##.....##.##..##..\n<b><span style='color:#EE9C34;'>.########...##.....##....##.....##.########..#####...\n<b><span style='color:#EE9C34;'>.##.....##..##....##.....##.....##.##...##...##..##..\n<b><span style='color:#EE9C34;'>.##.....##..##...##......##.....##.##....##..##...##.\n<b><span style='color:#EE9C34;'>.########..####.########..#######..##.....##.##....##\n<b><span style='color:#EE9C34;'>* * * * * * * * * * * * * * * * * * * * * * * * * * *\n You have been asleep for a long time.\n <i>Type 'awaken' to begin the game."}
      promptLabel={">"}
      autoFocus={true}
      ignoreCommandCase={false}
      styleEchoBack={'fullInherit'}
      errorText={`Huh? What's [command]?`}
    />
  );
};

const rootElement = document.getElementById("root");
ReactDOM.render(<MyTerminal />, rootElement);